//Grid Options
export const GRID_DATA = [
  {
    text: "Bootstrap grid system allow all six breakpoints, and any breakpoints you can customize.",
  },
];

export const GRID_OPTIONS_HEADER = [
  {
    title: "Medium",
    small: "≥576px",
  },
  {
    title: "Small",
    small: "≥768px",
  },
  {
    title: "Large",
    small: "≥992px",
  },
  {
    title: "Extra large",
    small: "≥1200px",
  },
  {
    title: "Extra extra large",
    small: "≥576px",
    className: "digits",
  },
];

export const CONTAINER_WIDTH = [
  "None (auto)",
  "540px",
  "720px",
  "960px",
  "1140px",
  "1320px",
];

export const CLASS_PREFIX = [
  ".col-",
  ".col-sm-",
  ".col-md-",
  ".col-lg-",
  ".col-xl-",
  ".col-xxl-",
];

export const REST_GRID = [
  {
    title: "# of columns",
    td: "12",
  },
  {
    title: "Gutter width",
    td: "1.5rem (.75rem on left and right)",
  },
  {
    title: "Nestable",
    td: "Yes",
  },
  {
    title: "Offsets",
    td: "Yes",
  },
  {
    title: "Column ordering",
    td: "Yes",
  },
];

//Grid for column
export const COLUMN_DATA = [
  { text: "You may use predefined grid classes. Using ", code: ".col-md-*" },
  { text: "you can set the grid system." },
];

export const GRID_COLUMN = [
  { size: "2", item: "col-md-2" },
  { size: "2", item: "col-md-2" },
  { size: "3", item: "col-md-3" },
  { size: "4", item: "col-md-4" },
  { size: "5", item: "col-md-5" },
  { size: "7", item: "col-md-7" },
  { size: "6", item: "col-md-6" },
  { size: "6", item: "col-md-6" },
  { size: "8", item: "col-md-8" },
  { size: "4", item: "col-md-4" },
  { size: "9", item: "col-md-9" },
  { size: "3", item: "col-md-3" },
  { size: "10", item: "col-md-10" },
  { size: "2", item: "col-md-2" },
  { size: "12", item: "col-md-12" },
];

//Vertical Alignment
export const ALIGNMENT_DATA = [
  { text: "You can use the ", code: "align-items-*" },
  { text: " class to set the Vertical alignment." },
];

export const VERTICAL_ALIGNMENT = ["align-items-center", "align-items-end"];

//Horizontal alignment
export const ALIGNMENTS_DATA = [
  {
    text: "You can use the ",
    code: "justify-content-*",
  },
  {
    text: " class to set the horizontal alignment.",
  },
];

export const HORIZONTAL_ALIGNMENT = [
  "justify-content-center",
  "justify-content-end",
];

//Nesting
export const NESTING_DATA = [
  {
    text: "To nest your content with the default grid, add a new",
    code: ".row",
  },
  { text: " and set of ", code: ".col-sm-*" },
  { text: " columns within an existing ", code: ".col-sm-*" },
  {
    text: " column.",
  },
];

//Order
export const ORDER_DATA = [
  { text: "Using ", code: ".order " },
  { text: "class, you can set the order position." },
];

export const ORDER_LIST = [
  {
    extraSmallSize: "5",
    item: "Second Item",
    order: "order-first",
  },
  {
    extraSmallSize: "4",
    item: "Third Item",
    order: "order-last",
  },
  {
    extraSmallSize: "3",
    item: "Fourth Item",
    order: "order-2",
  },
  {
    extraSmallSize: "4",
    smallSize: "2",
    item: "fifth Item",
    order: "order-5",
  },
  {
    extraSmallSize: "4",
    smallSize: "6",
    item: "sixth Item",
    order: "order-4",
  },
];

//Offset
export const OFFSET_DATA = [
  { text: "You can offset the grid column using ", code: ".offset-" },
  { text: " grid class." },
];

export const OFFSET_LIST = [
  {
    extraSmallSize: "4",
    smallSize: "2",
    className: "offset-sm-2 offset-1",
    item: "col-2 offset-2",
  },
  {
    extraSmallSize: "5",
    smallSize: "4",
    className: "offset-2",
    item: "col-4 offset-2",
  },
  {
    extraSmallSize: "4",
    smallSize: "3",
    className: "offset-sm-2 offset-1",
    item: "col-3 offset-2",
  },
];
